import type {VariantProps} from "class-variance-authority";

import {badgeVariants} from "@/components/ui/badge";

import type {DailyActivityReport} from "../types";

export type DarCodeName = DailyActivityReport["code"]["name"];

export const DAR_CODE_BADGE_VARIANTS = {
  Green: "success",
  Yellow: "warning",
  Red: "error",
} as const satisfies Record<DarCodeName, NonNullable<VariantProps<typeof badgeVariants>["variant"]>>;

/** @deprecated Use `DAR_CODE_BADGE_VARIANTS` — kept for existing DAR list imports. */
export const BADGE_VARIANTS = DAR_CODE_BADGE_VARIANTS;
